import React from 'react';
import styled from '@emotion/styled';
import { RedBgButton } from '../../../components/Button/Buttons';

const PlayBig = () => {
  return (
    <Container>
      <Content>
        <TextSection>
          <Heading>
            Play it big with CML!
          </Heading>
          <Paragraph>
            Become a part of our fast-growing storage and distribution <br /> network and enjoy business-friendly pricing.
          </Paragraph>
          <RedBgButton onClick={() => window.open('https://forms.gle/8wbePJz9d6ij1i5s7', "_blank")}>Become A Partner</RedBgButton>
        </TextSection>
      </Content>
    </Container >
  );
};

export default PlayBig;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 -5.4375rem -1rem;
  padding: 3rem 5.4375rem;
  position: relative;
  overflow: hidden;
  background-image: url('/static/img/cml/play_it_big.jpg');
  background-size: cover;
  background-position: center center;

  width: 100vw;
  max-height: 700px;
  min-height: 600px;

  @media (max-width: 884px) {
    padding: 0;
    margin: 0 -24px;
    min-height: calc(100vh - 60px);
  }

    @media (max-width: 480px) {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;


const Content = styled.section`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 48px;

  @media (max-width: 884px) {
    justify-content: center;
    text-align: center;
  }

    @media (max-width: 480px) {
    margin: 60px 0 0 24px;

  }

`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 884px) {
    align-items: center;
  }

    @media (max-width: 480px) {
    align-items: flex-start;
  }

  button{
  width: fit-content}
`;

const Heading = styled.h1`
  font-size: 60px;
  font-weight: 700;
  color: #fff;

  span {
    color: ${({ theme }) => theme.palette.redFontColor}; /* red shade */
  }

  @media (max-width: 884px) {
    font-size: 28px;
  }
`;

const Paragraph = styled.p`
  font-size: 20px;
  line-height: 1.6;
  color: #fff;
  font-weight: 500;

  @media (max-width: 884px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    margin:0;
    padding:0;
    text-align: left;


    & br{
      display: none;
    }
  }
`;


